import React, { Component } from "react";
import Button from "../../../../components/common/button/Button";
import styles from "./CompanyAffiliation.scss";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Textarea from "../../../../components/common/textarea/Textarea";
import { Form, FormGroup } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import {
  required,
  alphaNumericSpace,
  dropdown,
  maxLength
} from "../../../../utils/forms/validators";
import { connect } from "react-redux";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";

export const alphaNumericSpaceValidation = msg => alphaNumericSpace(msg);
export const dropdownValidation = msg => dropdown(msg);
export const maxLengthValidation = (max, msg) => maxLength(max, msg);

export const location = alphaNumericSpaceValidation(
  "Please enter a valid Location."
);
export const industry = dropdownValidation("Please select an Industry.");
export const companySize = dropdownValidation("Please select a Company Size.");
export const summary = maxLengthValidation(
  280,
  "Summary must be less than or equal to 280 characters."
);

class CompanyAffiliation extends Component {
  componentDidMount() {}

  render() {
    const {
      submitting,
      valid,
      industries,
      companySizes,
      onSearchCities,
      isLoading,
      cities
    } = this.props;

    return (
      <section className={styles.companyAffiliation}>
        <ScrollToTopOnMount />
        <div className={styles.content}>
          <h2 className={styles.title}>Edit Account Information</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.subheading}>
                  Note! Only do this if you've actually changed companies. All
                  futures jobs will be posted under this new company. Other
                  warnings and such about what this'll do to your account.
                </div>
              </FormGroup>
              <FormGroup>
                <Field
                  name="company"
                  placeholder="Company Name"
                  component={Typeahead}
                  newSelectionPrefix="Add new company: "
                  paginationText="Display additional companies..."
                  onSearch={query => this.props.onSearchCompanies(query)}
                  isLoading={this.props.isLoading}
                  options={this.props.companies}
                  isAsync={true}
                  minLength={3}
                  labelKey="name"
                  validate={[required]}
                  allowNew={true}
                />

                <Field
                  name="industry_id"
                  type="select"
                  placeholder="Industry"
                  component={Select2}
                  options={industries}
                  validate={industry}
                />

                <Field
                  name="company_size_id"
                  type="select"
                  placeholder="Company Size"
                  component={Select2}
                  options={companySizes}
                  validate={companySize}
                />

                <Field
                  name="location"
                  placeholder="Location"
                  component={Typeahead}
                  onSearch={query => onSearchCities(query)}
                  isLoading={isLoading || false}
                  options={cities}
                  isAsync={true}
                  minLength={3}
                  allowNew={false}
                  labelKey="description"
                  valueKey="id"
                  validate={required}
                  icon="map-marker"
                  focusOut={selected => {
                    if (!selected) {
                      this.props.change("location", null);
                    }
                  }}
                  onSearch={query => onSearchCities(query)}
                />

                <Field
                  name="url"
                  type="text"
                  placeholder="Website or LinkedIn Page"
                  component={Input}
                  validate={required}
                />

                <Field
                  name="summary"
                  type="textarea"
                  placeholder="Describe your company to prospective
                  freelancers and employees (you can edit this later)."
                  component={Textarea}
                  help={"Please enter a brief description of your company."}
                  maxlength={280}
                  label="Company Summary"
                  validate={[required, summary]}
                />

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Change to New Company"
                  isDisabled={!valid || submitting}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

CompanyAffiliation = reduxForm({
  form: "CompanyAffiliation",
  enableReinitialize: true,
  touchOnChange: true
})(CompanyAffiliation);

CompanyAffiliation = connect(
  state => {
    return {
      initialValues: state.companyProfile.data
    };
  },
  dispatch => ({
    load: data => dispatch(loadCompanyProfile(data))
  })
)(CompanyAffiliation);

export default CompanyAffiliation;



// WEBPACK FOOTER //
// ./src/routes/employer/companyAffiliation/components/CompanyAffiliation.js